import { Outlet } from 'react-router-dom'
import './AdminPanelLayOut.css'
import AdminNavBare from '../../components/Admin-page-componets/Admin-navBare/AdminNavBare'

const AdminPanelLayOut = () => {
  return (
    <div className="AdminPanelLayOut">
      <AdminNavBare  />
      <div className="AdminPanelLayOut-body">
        <div className="AdminPanelLayOut-body-right">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default AdminPanelLayOut